import React, { useRef, useEffect, useState} from 'react';
import './Introduction.css'
import graphic from './../../Assets/TestGraphic.png'
import CodeBlock from '../../Components/Docs/CodeBlock';
import {json_lang, curl_lang, axios_lang} from './Lang'


function Introduction({setIsVisible}) {

    const [json, setjson] = useState(true);
    const [curl, setcurl] = useState(false);
    const [axios, setaxios] = useState(false);
    const [body, setbody] = useState("\n\n{\n \"email\": [\"Will u meet ur dream partner soon? Is ur career off 2 a flyng start? 2 find out free, txt HORO followed by ur star sign, e. g. HORO ARIES\"] \n }\n\n");


    const click = (name) =>{
        
        console.log(name);
        switch (name) {
            case 'json':
                setjson(true);
                setcurl(false);
                setaxios(false);
                setbody(json_lang);
              break;
            case 'curl':
                setjson(false);
                setcurl(true);
                setaxios(false);
                setbody(curl_lang);
              break;
            case 'axios':
                setjson(false);
                setcurl(false);
                setaxios(true);
                setbody(axios_lang);
              break;
          }
          
    }

    const response = "\n\n{\n \"spam\": true \n} \n\n";
    const text = "Example request body and all possible response fields";

    
      // ******************* Observe if the component is loaded in the viewport **************

      const targetRef = useRef(null);
  
      useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            // entry.isIntersecting is true when the target element is visible
            if(entry.isIntersecting){
              setIsVisible("introduction");
            }
          },
          {
            root: null, // use the viewport as the root
            rootMargin: '0px', // no margin
            threshold: 0.5, // 0.5 means at least 50% of the target element must be visible
          }
        );
    
        if (targetRef.current) {
          observer.observe(targetRef.current);
        }
    
        // Cleanup the observer when the component is unmounted
        return () => {
          if (targetRef.current) {
            observer.unobserve(targetRef.current);
          }
        };
      }, []);


    return (
        <div ref={targetRef} id='docs_introduction'>
            <div className='docs_side_text'>
                <h1>👋 Introduction</h1>
                <p>Welcome to the Email-Spamming SheildScan API!</p>
                <p>Email-Spamming SheildScan API is a highly accurate anti-spam filter.</p>
                <br/>
                <p>It is usually used for:</p>
                <p>1. Protect Websites & Databases</p>
                <p>2. Filter & Review Emails</p>
                <br/>
                <h3>Submit messages to the API and it will generate a spam boolean. Using the boolean you can adjust the sensitivity level (also known as spam threshold) of spam filtering to suit your use case.</h3>
                <img src={graphic} />
                <p>You can test the API directly in your browser with your data on the SheildScan Dashboard.</p>
                <p>The API is built around REST. All requests should be made over SSL. All request and response bodies, including errors, are encoded in JSON.</p>
            </div>
            <div className='docs_side_code'>
                <div className='code_box'>
                    <div className='Code_snippet_lang'>
                        <div className={json ? 'active_lang': 'lang'} onClick={() => click('json')}>
                            <h1>Json</h1>
                        </div>
                        <div className={curl ? 'active_lang': 'lang'} onClick={() => click('curl')} >
                            <h1>cURL</h1>
                        </div>
                        <div className={axios ? 'active_lang': 'lang'} onClick={() => click('axios')} >
                            <h1>Axios</h1>
                        </div>
                    </div>
                    <CodeBlock body={body} response={response} displayres={true} text={text}/>
                </div>
            </div>
        </div>
    )
}

export default Introduction
